
import React, { useState, useEffect } from 'react';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-10 right-10 z-40 p-4 transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] bg-vanity-white/80 backdrop-blur-md border border-vanity-charcoal/10 rounded-full shadow-lg group hover:border-vanity-pink ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      aria-label="Back to top"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        className="text-vanity-black group-hover:text-vanity-pink transition-colors duration-300"
      >
        <path d="M12 19V5M5 12l7-7 7 7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 font-sans text-[9px] uppercase tracking-[0.4em] text-vanity-black opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden md:block">
        Back to top
      </span>
    </button>
  );
};

export default BackToTop;
